<template>
  <section>
    <div v-if="cancellationMode" class="cancellation-mode">
      <aRow type="flex" justify="space-between">
        <aCol class="upper">
          <img
            class="mr-5"
            src="@/assets/images/dashboard/contracts/cancel-model.png"
            alt="icon"
          />
          Aditivo de Vendas

          <aDivider type="vertical" />

          <aRadioGroup
            class="cancel-specific"
            v-model="salesAdditiveType"
            :disabled="loadingSalesAdditiveType"
            @change="onChangeSalesAdditiveType"
          >
            <aRadio
              :value="'Alterar'"
              :disabled="
                tempContract.package_type === 'Pacote Completo Terceiros'
              "
            >
              Alterar Produtos
            </aRadio>
            <aRadio
              :value="'Cancelar'"
              :disabled="
                tempContract.package_type === 'Pacote Completo Terceiros'
              "
            >
              Cancelar Produtos
            </aRadio>
            <aRadio :value="'Cancelar Venda'"> Cancelar Venda </aRadio>
          </aRadioGroup>
        </aCol>

        <aCol v-if="salesAdditiveType === 'Cancelar Venda'">
          <aButton
            class="cancel-sale"
            :disabled="disableCancelSale"
            type="link"
            @click="onClickOpenCancelSaleModal"
          >
            <img
              class="mr-5"
              src="@/assets/images/dashboard/contracts/cancel-sale.png"
              alt="icon"
            />
            Cancelar Toda Venda
          </aButton>
        </aCol>
      </aRow>

      <aModal
        v-if="salesAdditiveType === 'Cancelar Venda'"
        :visible="openCancelAllSaleModal"
        :footer="false"
        @cancel="openCancelAllSaleModal = false"
        :width="600"
        class="cancel-sale-modal"
      >
        <template #title> CANCELAR TODA VENDA</template>

        <ContractCancelModeModal
          v-if="openCancelAllSaleModal"
          :tempContract="tempContract"
          :allContractData="allContractData"
          :productHasFee="productHasFee"
          :cancellationMode="cancellationMode"
          :cancelActions="cancelActions"
          :salesAdditiveType="salesAdditiveType"
          :disableCancelSale="disableCancelSale"
          :totalFees="totalFees"
          @onContractCancelModeFinish="onContractCancelModeFinish"
        />
      </aModal>
    </div>

    <aRow
      v-if="
        cancellationMode && ['Alterar', 'Cancelar'].includes(salesAdditiveType)
      "
      class="select-products"
    >
      <aCol>
        <aCheckboxGroup
          v-model="productsToCancel"
          :disabled="loadingSalesAdditiveType"
          @change="onChangeProductsToCancel"
        >
          <span v-for="(product, i) in listProductsToCancel" :key="i">
            <aTooltip>
              <template slot="title"> {{ product.altName }} </template>
              <aCheckbox :value="product.rowId"> {{ product.name }} </aCheckbox>
            </aTooltip>
          </span>
        </aCheckboxGroup>
      </aCol>
    </aRow>

    <div class="contract-header">
      <aRow :gutter="10">
        <aCol :span="4">
          <div class="box">
            <div class="title cprimary">ID {{ tempContract.id }}</div>
            <div class="value dotted-phrase mt-5 f10">
              {{ contract.user ? contract.user.first_name : "" }}
              {{ contract.user ? contract.user.last_name : "" }}
            </div>
          </div>
        </aCol>

        <aCol :span="5">
          <div class="box">
            <div class="title">TOTAL</div>
            <div class="value">
              {{ formatPricePtBr(allContractData.total) }}
            </div>
          </div>
        </aCol>

        <aCol :span="5">
          <div class="box">
            <div class="title">A PAGAR</div>
            <div class="value">
              {{ formatPricePtBr(allContractData.totalNet) }}
            </div>
          </div>
        </aCol>

        <aCol :span="4">
          <div class="box">
            <div class="title">TAXAS</div>
            <div class="value">
              {{ formatPricePtBr(allContractData.totalTaxes) }}
            </div>
          </div>
        </aCol>

        <aCol :span="6">
          <div class="box">
            <div class="title">LUCRO</div>
            <div class="value cgreen">
              {{ formatPricePtBr(allContractData.totalProfit) }}
              ({{ formatPercentage(allContractData.totalProfitPercentage) }}%)
            </div>
          </div>
        </aCol>
      </aRow>
    </div>
  </section>
</template>

<script>
import formatThings from "@/mixins/general/formatThings";
import ContractCancelModeModal from "@/components/contracts/modals/ContractCancelModeModal.vue";

export default {
  name: "ContractModalHeader",
  props: {
    tempContract: Object,
    contract: Object,
    allContractData: Object,
    productHasFee: Boolean,
    cancellationMode: Boolean,
    salesAdditiveType: String,
    disableCancelSale: Boolean,
    productsToCancel: Array,
    totalFees: Number,
  },
  components: {
    ContractCancelModeModal,
  },
  mixins: [formatThings],
  data() {
    return {
      loadingSalesAdditiveType: false,
      openCancelAllSaleModal: false,
      cancelActions: [],
      listProductsToCancel: [],
    };
  },
  mounted() {
    if (["Alterar", "Cancelar"].includes(this.salesAdditiveType)) {
      this.genListProductsToCancel();
    } else {
      //this.onClickOpenCancelSaleModal()
    }
  },
  methods: {
    onChangeProductsToCancel(value) {
      this.loadingSalesAdditiveType = true;
      this.productsToCancel = value;

      this.$http
        .post("/contract/update-multi-meta", {
          id: this.tempContract.id,
          products_to_cancel: JSON.stringify(value),
          modified_by: {
            name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
            id: this.$store.state.userData.id,
          },
        })
        .then(() => {
          this.$message.success("Contrato atualizado!");
          setTimeout(() => {
            this.$emit("onChangeProductsToCancel", value);
          }, 1000);
        })
        .finally(() => (this.loadingSalesAdditiveType = false));
    },
    onContractCancelModeFinish() {
      this.openCancelAllSaleModal = false;
      this.$emit("onContractCancelModeFinish");
    },
    onChangeSalesAdditiveType(e) {
      if (["Alterar", "Cancelar"].includes(e.target.value)) {
        this.genListProductsToCancel();
      }

      this.loadingSalesAdditiveType = true;

      this.$http
        .post("/contract/update-multi-meta", {
          id: this.tempContract.id,
          sales_additive_type: e.target.value,
          modified_by: {
            name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
            id: this.$store.state.userData.id,
          },
        })
        .then(() => {
          this.$message.success("Contrato atualizado!");
          setTimeout(() => {
            this.$emit("changeSalesAdditiveType", e.target.value);
            this.$http.post("/log/create", {
              user_id: this.$store.state.userData.id,
              module_id: this.tempContract.id,
              module: "contract",
              action: `contract-sales-additive-type`,
              description: `<b>[ADITIVO DE VENDAS]</b> <font class="user">${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}</font> marcou para <b>${e.target.value}</b>.`,
            });
          }, 100);
        })
        .finally(() => (this.loadingSalesAdditiveType = false));
    },
    onClickOpenCancelSaleModal() {
      this.openCancelAllSaleModal = true;

      this.cancelActions = [];

      if (this.salesAdditiveType === "Cancelar Venda") {
        if (this.totalFees !== 0 && this.productHasFee) {
          let taxInfo = "";

          taxInfo = `<div class="f11 red mt-5">➟ O valor de <b class="cred">${this.formatPricePtBr(
            this.totalFees
          )}</b> das taxas foi descontado na Carta de Crédito.</div>`;

          this.cancelActions.push({
            action: "create-credit-letter",
            text: `Uma <b>CARTA DE CRÉDITO</b> no valor de <b class="cgreen">${this.formatPricePtBr(
              this.allContractData?.total - this.totalFees
            )}</b> será gerada no nome do cliente <b>${
              this.tempContract.the_customer.first_name
            } ${this.tempContract.the_customer.last_name} (ID: ${
              this.tempContract.the_customer.id
            })</b>. ${taxInfo}`,
            done: false,
            loading: false,
          });
        } else {
          this.cancelActions.push({
            action: "create-credit-letter",
            text: `Uma <b>CARTA DE CRÉDITO</b> no valor de <b class="cgreen">${this.formatPricePtBr(
              this.allContractData?.total
            )}</b> será gerada no nome do cliente <b>${
              this.tempContract.the_customer.first_name
            } ${this.tempContract.the_customer.last_name} (ID: ${
              this.tempContract.the_customer.id
            })</b>.`,
            done: false,
            loading: false,
          });
        }

        this.cancelActions.push({
          action: "create-note-contract",
          text: `Uma NOTA será criada neste <b>CONTRATO (ID: ${this.tempContract.id})</b> sinalizando o cancelamento.`,
          done: false,
          loading: false,
        });

        this.cancelActions.push({
          action: "cancel-contract",
          text: `Cancelamento deste <b>CONTRATO (ID: ${this.tempContract.id})</b>.`,
          done: false,
          loading: false,
        });

        if (this.tempContract.sale_id != 0) {
          this.cancelActions.push({
            action: "cancel-sale",
            text: `Cancelamento da <b>VENDA (ID: ${this.tempContract.sale_id})</b>, associada a este contrato.`,
            done: false,
            loading: false,
          });
        }
      }
    },
    genListProductsToCancel() {
      const contractedServices = JSON.parse(
        this.tempContract.contracted_services
      );

      const products = [];

      if (contractedServices.includes("hotel")) {
        const hotels = JSON.parse(this.tempContract["hotel_rows"]);
        for (const hotel of hotels) {
          products.push({
            id: hotel.id,
            rowId: `hotel-${hotel.id}`,
            type: "hotel",
            name: `Hotel ${hotel.id}`,
            altName: `${this.tempContract[`hotel_${hotel.id}_name`] ?? ""}`,
          });
        }
      }

      if (contractedServices.includes("flight")) {
        const flights = JSON.parse(this.tempContract["flight_sections_rows"]);
        for (const flight of flights) {
          let allSections = "";
          flight.sections.forEach((section) => {
            allSections += `${
              this.tempContract[
                `flight_${flight.id}_section_${section.id}_origin`
              ]
            } ✈ ${
              this.tempContract[
                `flight_${flight.id}_section_${section.id}_destination`
              ]
            } | `;
          });

          products.push({
            id: flight.id,
            rowId: `flight-${flight.id}`,
            type: "flight",
            name: `Aéreo ${this.tempContract[`flight_${flight.id}_type`]} ${
              flight.id
            }`,
            altName: `${allSections ? allSections.slice(0, -3) : "Aéreo"}`,
          });
        }
      }

      if (contractedServices.includes("service")) {
        const services = JSON.parse(this.tempContract["service_rows"]);
        for (const service of services) {
          products.push({
            id: service.id,
            rowId: `service-${service.id}`,
            type: "service",
            name: `Serviço ${service.id}`,
            altName: `${
              this.tempContract[`service_${service.id}_type`] ?? "Tipo"
            } - ${this.tempContract[`service_${service.id}_name`] ?? "Nome"}`,
          });
        }
      }

      this.listProductsToCancel = products;
    },
  },
};
</script>

<style lang="scss">
.select-products {
  padding: 6px 10px;
  border-bottom: 1px solid #e0e0e0;
  background: #fafafa;
  .ant-checkbox-group {
    gap: 8px 16px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    label {
      font-weight: 500;
      color: #333;
      font-size: 12px;
    }
  }
}

.cancellation-mode {
  background: #ff4545;
  padding: 6px 15px;
  border-radius: 6px 6px 0 0;
  font-weight: 600;
  color: #fff;

  .cancel-specific {
    color: #fff;
    font-size: 12px;
    text-transform: none;
    font-weight: 500;
    .ant-radio-wrapper {
      color: #fff;
      font-size: 12px;
    }

    .ant-radio-wrapper-disabled span {
      color: #fff;
      opacity: 0.5;
    }

    .ant-radio-inner::after {
      color: #ff4545;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #fff;
      border-color: #fff;
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: #ff0000;
    }
  }
  .cancel-sale {
    color: #fff;
    height: auto;
    font-size: 13px;
  }
  .cancel-sale:hover {
    color: #fff;
  }
  .cancel-sale[disabled] {
    opacity: 0.5;
  }
}
</style>

<style lang="sass" scoped>
.contract-header
  padding: 10px
  border-bottom: 1px solid #e0e0e0
  .box
    border-radius: 6px
    font-size: 14px
    padding: 10px
    border-radius: 6px
    border: 1px solid #ddd
    height: 58px
    .title
      color: #bcbec0
      font-weight: 600
    .value
      color: #333
      font-weight: 600
  h1
    font-weight: 600
    font-size: 18px !important
    margin: 0
    padding: 0
    letter-spacing: -1px
    text-transform: uppercase
</style>
